import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './SubmissionConfirmation.css';

const SubmissionConfirmation = ({ type, customerCopySent }) => {
  const heading = useRef(null);
  const registration = type === 'registration';
  const missingCopy = !registration && !customerCopySent;

  useEffect(() => {
    heading.current.focus();
  }, []);

  return (
    <div className="submission-confirmation-stage">
      <section className="submission-confirmation" role="status" aria-live="polite" aria-atomic="true">
        <div className="submission-confirmation__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="m5 12 4 4 10-10" />
          </svg>
        </div>
        <h2 className="submission-confirmation__heading" ref={heading} tabIndex={-1}>
          {registration ? 'Registration received' : 'Order submitted'}
        </h2>
        <p className="submission-confirmation__description">
          {registration
            ? 'Thank you for requesting a Dotline Design wholesale account.'
            : 'Your order was sent to Dotline Design.'}
        </p>
        <div className={'submission-confirmation__detail' + (missingCopy ? ' submission-confirmation__detail--warning' : '')}>
          <strong>{registration ? 'Next step: email us' : missingCopy ? 'Confirmation email unavailable' : 'Confirmation emailed'}</strong>
          {registration ? (
            <p>To complete your request, email <a href="mailto:customerservice@dotlinedesign.com">customerservice@dotlinedesign.com</a> from the address you registered with.</p>
          ) : (
            <p>{missingCopy
              ? 'We could not email your confirmation copy. Please contact us if you need a copy.'
              : 'A confirmation was emailed to you.'}</p>
          )}
        </div>
        {registration ? (
          <a className="submission-confirmation__action" href="mailto:customerservice@dotlinedesign.com">Email customer service</a>
        ) : (
          <Link className="submission-confirmation__action" to="/products">Done</Link>
        )}
        <p className="submission-confirmation__note">
          {registration ? 'Our team will review your account before enabling access.'
            : missingCopy ? 'Your order was submitted successfully. No need to submit it again.'
            : 'You can continue shopping whenever you are ready.'}
        </p>
      </section>
    </div>
  );
};

export default SubmissionConfirmation;
